import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from '@src/service/axios';
import { toast } from 'react-toastify';

export const getInboxShiftRequest = createAsyncThunk('inboxShift/getRequest', async (data) => {
    try {
        const response = await axios.post('/ShiftChange/get-request', data, {
            headers: { 'Content-Type': 'application/json' }
        });

        return response?.data;
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const updateInboxShiftChangeRemark = createAsyncThunk('inboxShift/updateRemarks', async (data) => {
    try {
        const response = await axios.put('ShiftChange/request-status/' + data?.id, data?.data, {
            headers: { 'Content-Type': 'application/json' }
        });

        toast.success(response?.data?.message || 'Status updated successfully.');
        return response?.data;
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

const inboxShiftChangeSlice = createSlice({
    name: 'inboxShift',
    initialState: {
        shiftRequest: []
    },
    reducers: {
        removeInboxShiftChange: (state) => {
            state.shiftRequest = [];
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getInboxShiftRequest.fulfilled, (state, action) => {
            state.shiftRequest = action?.payload;
        });
    }
});

export const { removeInboxShiftChange } = inboxShiftChangeSlice.actions;
export default inboxShiftChangeSlice.reducer;
